import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import $ from "jquery";
import { useEffect, useState } from "react";
import { track_event } from "../FunctionsCore";
import { addToRenderableData, classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import DunsMgrClaimCtaStyles from "./DunsMgrClaimCtaStyles.module.scss";
const styles = DunsMgrClaimCtaStyles;
const classCombiner = classCombinerFromPrefix("e7a9ca5f6b8a317c");
const DunsMgrClaimCtaComponent = (props) => {
    const { dunsMgrClaimCtaData, inAnchorsComponent } = props;
    const { claimCompanyLinkRewritten, claimed, enableDunsManagerClaimCompanyCta, organizationDunsEncrypted, organizationPrimaryName, properties, unclaimed, updateClaimedLinkRewritten } = dunsMgrClaimCtaData;
    const [circledIButtonOnLeft, setCircledIButtonOnLeft] = useState(true);
    const [clickToggleState, setClickToggleState] = useState(false);
    const [mouseOverTooltip, setMouseOverTooltip] = useState(false);
    useEffect(() => {
        const mediaQueryList = window.matchMedia("screen and (max-width: 767px)");
        const handleMediaQueryListMediaQueryListEvent = (me) => setCircledIButtonOnLeft(!me.matches);
        mediaQueryList.addEventListener("change", (me) => handleMediaQueryListMediaQueryListEvent(me));
        handleMediaQueryListMediaQueryListEvent(mediaQueryList);
        $(window.document).on("click", (cl) => {
            if (!$(cl.target).hasClass(classCombiner(styles, "iconTooltip")[1])) {
                setClickToggleState(false);
            }
        });
    }, []);
    if (claimed && unclaimed) {
        throw new Error('"claimed" and "unclaimed" cannot both be true');
    }
    const showTooltip = clickToggleState || mouseOverTooltip;
    const claimedOrUnclaimed = () => {
        let claimCtaLink;
        let claimedStatusHeaderMessage;
        let claimStatusTooltipText;
        let clickEventName;
        let tooltipAriaLabel;
        if (claimed) {
            claimCtaLink = updateClaimedLinkRewritten;
            claimedStatusHeaderMessage = properties["claimedBadgeText"];
            claimStatusTooltipText = properties["claimedToolTipText"];
            clickEventName = "log_into_acct_clicked";
            tooltipAriaLabel = properties["ariaLabelClaimedToolTip"];
        }
        else if (unclaimed) {
            claimCtaLink = claimCompanyLinkRewritten.replace("{{companyDuns}}", organizationDunsEncrypted);
            claimedStatusHeaderMessage = properties["claimCompanyBadgeText"];
            claimStatusTooltipText = properties["claimCompanyToolTipText"];
            clickEventName = "create_duns_mgr_acct_clicked";
            tooltipAriaLabel = properties["ariaLabelClaimCompanyToolTip"];
        }
        else {
            throw new Error('Expecting either "claimed" or "unclaimed" to be true');
        }
        const claimCompanySId = properties["claimCompanySId"];
        const claimStatusTooltipTextReplaced = claimStatusTooltipText.replace("{{dashboard_link_open}}", `<a href="${claimCtaLink}" target="_blank">`).replace("{{dashboard_link_close}}", "</a>");
        const circledIButton = (onLeft) => inAnchorsComponent ? (_jsx(_Fragment, {})) : (_jsx("div", Object.assign({ className: cx(classCombiner(styles, "dunsMgrClaimHeaderButtonCta"), classCombiner(styles, onLeft ? "onLeft" : "onRight")) }, { children: _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "iconTooltipOuterWrapper")) }, { children: [_jsx("div", Object.assign({ className: cx(classCombiner(styles, "iconTooltipWrapper")), onMouseLeave: () => setMouseOverTooltip(false) }, { children: _jsx("div", { "aria-label": tooltipAriaLabel, className: cx(classCombiner(styles, "tooltipText"), classCombiner(styles, claimed ? "claimed" : "unclaimed"), showTooltip ? classCombiner(styles, "isVisible") : void 0), dangerouslySetInnerHTML: { "__html": claimStatusTooltipTextReplaced }, role: "img" }) })), _jsx("button", { className: cx(classCombiner(styles, "iconTooltip")), onClick: () => {
                            setClickToggleState((bo) => {
                                if (bo) {
                                    setMouseOverTooltip(false);
                                }
                                return !bo;
                            });
                        }, onMouseEnter: () => {
                            setMouseOverTooltip(true);
                        }, type: "button" })] })) })));
        const claimedButtonOrClaimLink = () => claimed ? (_jsxs("button", Object.assign({ className: cx(classCombiner(styles, "claimedCompany")), type: "button" }, { children: [_jsx("span", Object.assign({ className: cx(classCombiner(styles, "claimedStatusHeaderMessage")) }, { children: claimedStatusHeaderMessage })), _jsx("span", { className: cx(classCombiner(styles, "iconClaimedCheck")) })] }))) : (_jsx("a", Object.assign({ className: cx(classCombiner(styles, "claimThisCompany")), href: claimCtaLink, onClick: () => track_event(`${organizationPrimaryName} - ${clickEventName}`) }, { children: claimedStatusHeaderMessage })));
        return (_jsx("div", Object.assign({ className: cx(classCombiner(styles, "dunsMgrClaimCtaWrapper"), inAnchorsComponent ? classCombiner(styles, "inAnchorsComponent") : void 0), "data-id": claimCompanySId }, { children: circledIButtonOnLeft ? (_jsxs(_Fragment, { children: [circledIButton(true), claimedButtonOrClaimLink()] })) : (_jsxs(_Fragment, { children: [claimedButtonOrClaimLink(), circledIButton(false)] })) })));
    };
    return !claimed && !unclaimed || enableDunsManagerClaimCompanyCta !== "true" ? _jsx("span", { dangerouslySetInnerHTML: {
            "__html": `
<!--
    Skipping DunsMgrClaimCta component because company does not qualify as either claimed or unclaimed, or because enableDunsManagerClaimCompanyCTA is not "true"
-->`,
        }, style: { "display": "none" } }) : claimedOrUnclaimed();
};
const dunsMgrClaimCta = (renderableData) => renderIdentifierGeneric(DunsMgrClaimCtaComponent, addToRenderableData(renderableData, {
    "inAnchorsComponent": false
}));
export { dunsMgrClaimCta, DunsMgrClaimCtaComponent };
